define('presentation/analytics/viewModels/addScheduledReportModalViewModel',[
    'businessServices/authentication/sessionUserInfo',
    'businessServices/state/modelStateObserver',
    'common/promises/promiseFactory',
    'common/storage/commonState',
    'constants/scheduledReportDeliveryFrequencyConstants',
    'constants/scheduledReportDeliveryFormatConstants',
    'constants/scheduledReportGraphByConstants',
    'constants/timeframeConstants',
    'presentation/analytics/facades/addScheduledReportModalFacade',
    'presentation/analytics/validators/addScheduledReportModalViewModelValidator',
    'presentation/common/modal'
], function() {
    return function(duringValue, filterOnHostedNumbers, filterOnSystemObjects, isSendNow = false) {
        const self = this;

        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _commonState = require('common/storage/commonState');
        const _i18n = require('i18next');
        const _scheduledReportDeliveryFrequencyConstants = require('constants/scheduledReportDeliveryFrequencyConstants');
        const _scheduledReportDeliveryFormatConstants = require('constants/scheduledReportDeliveryFormatConstants');
        const _scheduledReportGraphByConstants = require('constants/scheduledReportGraphByConstants');
        const _sessionUserInfo = require('businessServices/authentication/sessionUserInfo');
        const _timeframeConstants = require('constants/timeframeConstants');

        let _facade = null;
        let _modalService = null;
        let _validator = null;

        const MAX_ITEMS_CAN_ADD = 10;

        self.modelStateObserver = null;
        self.isCompositionComplete = ko.observable(false);
        self.isScrollActive = ko.observable(false);
        self.shouldContentOverflow = ko.pureComputed(() => self.isCompositionComplete() && self.isScrollActive());
        self.showRequiredItemsWarning = ko.observable(false);

        self.headerText = ko.pureComputed(() => {
            if (isSendNow) {
                return _i18n.t('addScheduledReportModal:sendNow');
            } else {
                return _i18n.t('addScheduledReportModal:scheduleReport');
            }
        });

        self.subject = ko.observable("").extend({observeState: true});
        self.message = ko.observable("").extend({observeState: true});
        self.sendToEmailAddresses = ko.observableArray([]).extend({observeState: true});

        self.selectedDeliveryFormat = ko.observable(_scheduledReportDeliveryFormatConstants.Csv).extend({observeState: true});
        self.deliveryFormatOptions = [
            {id: _scheduledReportDeliveryFormatConstants.Csv, text: _i18n.t('addScheduledReportModal:csv')},
            {id: _scheduledReportDeliveryFormatConstants.Pdf, text: _i18n.t('addScheduledReportModal:pdf')}
        ];

        self.showGraphBy = ko.pureComputed(() => self.selectedDeliveryFormat() === _scheduledReportDeliveryFormatConstants.Pdf);
        self.selectedGraphBy = ko.observable(_scheduledReportGraphByConstants.Week).extend({observeState: true});
        self.graphByOptions = [
            {id: _scheduledReportGraphByConstants.Hour, text: _i18n.t('addScheduledReportModal:hour')},
            {id: _scheduledReportGraphByConstants.Day, text: _i18n.t('addScheduledReportModal:day')},
            {id: _scheduledReportGraphByConstants.Week, text: _i18n.t('addScheduledReportModal:week')},
            {id: _scheduledReportGraphByConstants.Month, text: _i18n.t('addScheduledReportModal:month')}
        ];

        self.showDeliveryFrequency = ko.pureComputed(() => isSendNow !== true);
        self.selectedDeliveryFrequency = ko.observable(_scheduledReportDeliveryFrequencyConstants.Daily).extend({observeState: true});
        self.deliveryFrequencyOptions = [
            {id: _scheduledReportDeliveryFrequencyConstants.Daily, text: _i18n.t('addScheduledReportModal:daily')},
            {id: _scheduledReportDeliveryFrequencyConstants.Weekly, text: _i18n.t('addScheduledReportModal:weekly')},
            {id: _scheduledReportDeliveryFrequencyConstants.Monthly, text: _i18n.t('addScheduledReportModal:monthly')}
        ];

        self.canAddAnotherEmailAddress = ko.pureComputed(() => self.sendToEmailAddresses().length < MAX_ITEMS_CAN_ADD);
        self.canDeleteEmailAddress = ko.pureComputed(() => self.sendToEmailAddresses().length > 0);
        self.addEmailAddressBtnText = ko.pureComputed(() => {
            if (self.canAddAnotherEmailAddress()) {
                return _i18n.t('addScheduledReportModal:addEmailAddress');
            } else {
                return _i18n.t('addScheduledReportModal:disabledAddEmailAddress');
            }
        });

        self.timeframeText = ko.pureComputed(() => {
            switch (duringValue) {
                case _timeframeConstants.today:
                    return _i18n.t('timeframe:today');
                case _timeframeConstants.thisWeek:
                    return _i18n.t('timeframe:thisWeek');
                case _timeframeConstants.thisMonth:
                    return _i18n.t('timeframe:thisMonth');
                case _timeframeConstants.thisQuarter:
                    return _i18n.t('timeframe:thisQuarter');
                case _timeframeConstants.thisYear:
                    return _i18n.t('timeframe:thisYear');
                case _timeframeConstants.yesterday:
                    return _i18n.t('timeframe:yesterday');
                case _timeframeConstants.lastWeek:
                    return _i18n.t('timeframe:lastWeek');
                case _timeframeConstants.lastMonth:
                    return _i18n.t('timeframe:lastMonth');
                case _timeframeConstants.lastQuarter:
                    return _i18n.t('timeframe:lastQuarter');
                case _timeframeConstants.lastYear:
                    return _i18n.t('timeframe:lastYear');
                case _timeframeConstants.monthToDate:
                    return _i18n.t('timeframe:monthToDate');
                case _timeframeConstants.quarterToDate:
                    return _i18n.t('timeframe:quarterToDate');
                case _timeframeConstants.yearToDate:
                    return _i18n.t('timeframe:yearToDate');
                case _timeframeConstants.lastDays7:
                    return _i18n.t('timeframe:lastDays7');
                case _timeframeConstants.lastDays14:
                    return _i18n.t('timeframe:lastDays14');
                case _timeframeConstants.lastDays30:
                    return _i18n.t('timeframe:lastDays30');
                case _timeframeConstants.lastDays60:
                    return _i18n.t('timeframe:lastDays60');
                case _timeframeConstants.lastDays90:
                    return _i18n.t('timeframe:lastDays90');
                case _timeframeConstants.lastMonths12:
                    return _i18n.t('timeframe:lastMonths12');
                case _timeframeConstants.custom:
                    return _i18n.t('timeframe:custom');
                default:
                    return '';
            }
        });

        const _addDefaultEmailAddress = () => {
            const email = {
                index: null,
                emailAddress: ko.observable('').extend({ rateLimit: 500 })
            };
            self.sendToEmailAddresses.push(email);
            _reIndexEmailAddresses();
        };

        const _extractEmailAddresses = (emailAddresses) => {
            return emailAddresses.map(email => email.emailAddress());
        };

        const _extractHostedNumberIds = (hostedNumbers) => {
            return hostedNumbers.map(number => number.id);
        };

        const _extractUserIds = (systemObjects) => {
            return systemObjects.filter(object => object.type === _commonState.types.user).map(user => user.id);
        };

        const _extractGroupIds = (systemObjects) => {
            return systemObjects.filter(object => object.type === _commonState.types.userGroup).map(group => _commonState.resolveGroupIdToGuid(group.id));
        };

        const _reIndexEmailAddresses = () => {
            self.sendToEmailAddresses().forEach((email, index) => email.index = index);
        };

        const _removeDuplicateFieldsBeforeValidation = () => {
            const duplicateEmailAddresses = self.sendToEmailAddresses().filter((email, index) => {
                return self.sendToEmailAddresses().find((e, i) => {
                    return e.emailAddress().trim() === email.emailAddress().trim() &&
                        index !== 0 &&
                        index !== i;
                });
            });
            self.sendToEmailAddresses.removeAll(duplicateEmailAddresses);
        };

        const _removeEmptyFieldsBeforeSave = () => {
            const emptyAddedEmailAddresses = self.sendToEmailAddresses().filter((email) => {
                return email.emailAddress().trim() === "";
            });
            self.sendToEmailAddresses.removeAll(emptyAddedEmailAddresses);
        };

        self.validate = () => {
            return _promiseFactory.defer((deferredObject) => {
                _validator.validateMinimumRequiredFields()
                    .fail(deferredObject.reject)
                    .done((hasAtLeastOneRequiredField) => {
                        self.showRequiredItemsWarning(!hasAtLeastOneRequiredField);
                        _validator.validate()
                            .fail(deferredObject.reject)
                            .done((isValid) => {
                                deferredObject.resolve(hasAtLeastOneRequiredField && isValid);
                            });
                    });
            });
        };

        const _saveScheduledReport = () => {
            return _promiseFactory.defer((promise) => {
                _removeDuplicateFieldsBeforeValidation();
                self.validate()
                    .fail(promise.reject)
                    .done((isValid) => {
                        if (isValid === false) {
                            promise.resolve();
                            return;
                        }

                        _removeEmptyFieldsBeforeSave();

                        const subject = self.subject().trim();
                        const message = self.message().trim();
                        const deliveryFormat = self.selectedDeliveryFormat();
                        const graphDataPointsBy = self.selectedGraphBy();
                        const deliveryFrequency = self.selectedDeliveryFrequency();
                        const emailAddresses = _extractEmailAddresses(self.sendToEmailAddresses());
                        const timeframe = duringValue;
                        const hostedNumberIds = _extractHostedNumberIds(filterOnHostedNumbers);
                        const userIds = _extractUserIds(filterOnSystemObjects);
                        const groupIds = _extractGroupIds(filterOnSystemObjects);

                        const facadePromise = isSendNow ?
                            _facade.sendOneTimeReport(
                                subject,
                                message,
                                deliveryFormat,
                                graphDataPointsBy,
                                emailAddresses,
                                timeframe,
                                hostedNumberIds,
                                userIds,
                                groupIds
                            ) :
                            _facade.saveScheduledReport(
                                subject,
                                message,
                                deliveryFormat,
                                graphDataPointsBy,
                                deliveryFrequency,
                                emailAddresses,
                                timeframe,
                                hostedNumberIds,
                                userIds,
                                groupIds
                            );

                        facadePromise
                            .fail(promise.reject)
                            .done((result) => {
                                if (result.isSuccessful) {
                                    _modalService.closeModal(self);
                                    promise.resolve();
                                } else {
                                    promise.reject();
                                }
                            });
                    });
            });
        };

        self.onRemoveEmailAddressClick = (emailToDelete) => {
            if (self.canDeleteEmailAddress() === false) {
                return;
            }
            self.sendToEmailAddresses.remove(emailToDelete);
        };

        self.onAddEmailAddressClick = () => {
            if (self.canAddAnotherEmailAddress() === false) {
                return;
            }
            _addDefaultEmailAddress();
        };

        self.onCancel = () => {
            self.isCompositionComplete(false);
            self.modelStateObserver.navigateWithoutWarning = true;
            return _promiseFactory.defer((promise) => {
                _modalService.closeModal(self);
                promise.resolve();
            });
        };

        self.onSave = () => {
            return _promiseFactory.defer((promise) => {
                _saveScheduledReport()
                    .fail(promise.reject)
                    .done(() => {
                        self.isCompositionComplete(false);
                        self.modelStateObserver.saveData();
                        _modalService.closeModal(self);
                        promise.resolve(true);
                    });
            });
        };

        self.compositionComplete = () => {
            self.modelStateObserver.isDirty(true);
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/analytics/facades/addScheduledReportModalFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const Modal = require('presentation/common/modal');
            _modalService = new Modal();

            const ValidatorConstructor = require('presentation/analytics/validators/addScheduledReportModalViewModelValidator');
            _validator = new ValidatorConstructor();

            return _initialize();
        };

        const _initialize = () => {
            _validator.registerViewModel(self);

            self.subject(_i18n.t('addScheduledReportModal:subjectTemplate') + ' ' + self.timeframeText());

            const loggedInUserEmail = {
                index: null,
                emailAddress: ko.observable(_sessionUserInfo.emailAddress()).extend({ rateLimit: 500 })
            };
            self.sendToEmailAddresses.push(loggedInUserEmail);

            self.modelStateObserver = new ModelStateObserverConstructor(self);
            self.modelStateObserver.commitData();

            return _promiseFactory.wait();
        };
    };
});

